import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { addInitialcart, addSelectedBook, addTocart, addTofavorite, changeQuantity, deleteItem, deletefavorite, resetCart, resetfavorite, removeUser } from '../redux/productSlice';
import axios, { all } from 'axios';
import bookPlaceHolder from "../../assets/bookPlaceHolder.png";

const AuthContext = React.createContext({
  selectedcurrency: {},
  setselectedcurrency:() => {},
  isPopupCartOpen: {},
  setisPopupCartOpen:() => {},
  addedBookCart: {},
  setaddedBookCart:() => {},
  currencyRate: {},
  setcurrencyRate:()=>{},
  selectedlanguage: {},
  setselectedlanguage:() => {},
  isLoading:{},
  reviewData:{},
  setReviewData:() =>{},
  bookDetails:{},
  setbookDetails:() =>{},
  returnData:{},
  ReturnSelectedPage: '',
  setReturnSelectedPage: () => {},
  setReturnData:() =>{},
  editreturnData:{},
  seteditReturnData:() =>{},
  addToCart:() =>{},
  addToCartWithQty:() =>{},
  deleteFromcart:() =>{},
  addToFavorite:() =>{},
  addToFavoriteWithCatigory:() =>{},
  deleteFavorite:() =>{},
  articleFamille: [],
  allarticleFamille: [],
  articleFamilleParents: [],
  subsubCategories: [],
  articles: [],
  categories: [],
  setArticles: () => {},
  fetchArticles: () => {},
  fetchCategories: () => {},
  companySettings: [],
  setCompanySettings: () => {},
  fetchCompanySettings: () => {},
  collections: [],
  setCollections: () => {},
  fetchCollections: () => {},
  collaborators: [],
  setCollaborators: () => {},
  fetchCollaborators: () => {},
  fetchfavandcartSettings:() => {},
  
  countries: [],
  setCountries: () => {},

  societeConfig: [],
  setSocieteConfig: () => {},
  favPopup:{},
  setFavPopup:() =>{},

  
  publishers: [],
  setPublishers: () => {},
});

export const AuthContextProvider = (props) => {

  const [selectedcurrency, setselectedcurrency] = useState('eur');
  const [isPopupCartOpen, setisPopupCartOpen] = useState(false);
  const [addedBookCart, setaddedBookCart] = useState({});
  const [currencyRate, setcurrencyRate] = useState(null);
  const [selectedlanguage, setselectedlanguage] = useState('fr');
  const [reviewData, setReviewData] = useState([]);
  const [bookDetails, setbookDetails] = useState({});
  const [returnData, setReturnData] = useState([]);
  const [editreturnData, seteditReturnData] = useState({});
  const [ReturnSelectedPage, setReturnSelectedPage] = useState('all');
  const [articles, setArticles] = useState([]);
  const [articleFamille, setarticleFamille] = useState([]);
  const [allarticleFamille, setAllarticleFamille] = useState([]);
  const [articleFamilleParents, setArticleFamilleParents] = useState([]);
  const [subsubCategories, setSubsubCategories] = useState([]);
  const [companySettings, setCompanySettings] = useState([]);
  const [categories, setCategories] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [collections, setCollections] = useState([]);
  const [societeConfig, setSocieteConfig] = useState([]);
  const [publishers, setPublishers] = useState([]);
  const [countries, setCountries] = useState([]);
  const [collaboratorsTypes, setCollaboratorsTypes] = useState([]);
  const dispatch = useDispatch();
  const productData = useSelector((state)=>state.products.productData);
  const favorites = useSelector((state)=>state.products.favorites);
  const user = useSelector((state)=>state.products.userInfo);
  const language = useSelector((state) => state.products.selectedLanguage[0].Language);
  const [isLoading, setIsLoading] = useState(false);
  const isAddingToCartRef = useRef(false);
  const [favPopup, setFavPopup] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [addtocartPopupOpen, setaddtocartPopupOpen] = useState(false);
  const [addtocartPopupId, setaddtocartPopupId] = useState(null);
  
    const selectedCategoryId = useSelector((state) => state.products.selectedCategoryId);
  const [articleFamilleId, setarticleFamilleId] = useState(selectedCategoryId || null);
  React.useEffect(() => {
            setarticleFamilleId(selectedCategoryId || null);
    }, [selectedCategoryId]);

  useEffect(() => {
    fetchArticleFamille();
    fetchArticles();
  }, [articleFamilleId,selectedCategoryId]);

  
  const token = sessionStorage.getItem('token');

  // QA: "account logout policy... active and kicked me out" with no
  // explanation. checkUserLoggedIn() below only re-validates the session
  // once, when the app first mounts — if the backend token expires or gets
  // revoked mid-visit (no fixed "10 min" timer exists in this codebase; the
  // token's own expiry is set at login, 1 day by default / 30 with "remember
  // me" — see AuthController@login), nothing noticed until whatever API call
  // happened to 401 next, which then just failed with no explanation, no
  // toast, nothing to tell the shopper they'd been signed out. A global
  // response interceptor catches that 401 the moment it happens, wherever it
  // happens, and shows the same "session ended" toast checkUserLoggedIn
  // already uses (shared toastId so the two paths can't double up if both
  // fire around the same time).
  useEffect(() => {
    const sessionEndedMsg = language === "eng"
      ? "Session ended, please login again."
      : "Session terminée, veuillez vous reconnecter.";

    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const wasLoggedIn = Boolean(sessionStorage.getItem('token'));
        if (error?.response?.status === 401 && wasLoggedIn) {
          sessionStorage.removeItem('token');
          dispatch(removeUser());
          toast.info(sessionEndedMsg, {
            toastId: "session-ended",
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          });
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptorId);
    };
  }, [language, dispatch]);

  const setReviewDatahandler = (reviewData) => {
    setReviewData(reviewData)
  }
  
  const setBookDetailshandler = (reviewData) => {
    setbookDetails(reviewData)
    dispatch(addSelectedBook(reviewData))
  }

  const addToCarthandler = async (propss) => {
    if (isLoading || isAddingToCartRef.current) {
      return;
    }

    const props = propss.props ? propss.props : propss;

    const hasVariantProduct =
      (props?.variant_product?.variant_product_combine_fields?.length || 0) > 0 &&
      (props?.variant_product?.variants?.length || 0) > 0;
    const hasResolvedVariantProduct = Boolean(props?.selected_variant_product?.id);

    if (hasVariantProduct && !hasResolvedVariantProduct) {
      setaddtocartPopupId(props?.id || null);
      setaddtocartPopupOpen(true);
      return;
    }

    const addToCartSuccessMessage = language === 'eng'
      ? 'Item is added to Cart'
      : "L'article est ajouté au panier";

    isAddingToCartRef.current = true;
    setIsLoading(true);
    const data = {
      article_id: props.id,
      user_id: user?.id || null,
      quantity: props.items_quantity,
      article: props,
        child_articles: props.child_articles || [],
      cart_items_variants: props?.selectedvariants,
      article_variant_combination: props?.article_variant_combination,
      b_usr_article_variant_combination_id: props?.article_variant_combination?.id
    };
    try {
      // Find if product already exists in the cart (match by id and variants)
      let userexistingarticle = null;
      if (data.article_variant_combination) {
        userexistingarticle = productData.find(item => 
          item?._id === data.article_id && item.article_variant_combination?.id === data.b_usr_article_variant_combination_id
        );
      } else {
        userexistingarticle = productData.find(item => item?._id === data.article_id);
      }

      // Helper to get max allowed quantity
      const getMaxQty = () => {
        if (props?.article_variant_combination?.id) {
          return Number(props.article_variant_combination?.quantity || 0);
        }
        return Number(props?._qte_a_terme_calcule || 0);
      };

      // Calculate new quantity
      let newQty;
      if (userexistingarticle) {
        newQty = userexistingarticle.quantity + (props.items_quantity ? props.items_quantity : 1);
        const maxQty = getMaxQty();
        if (maxQty > 0 && newQty > maxQty) newQty = maxQty;
      } else {
        newQty = data.quantity || 1;
        const maxQty = getMaxQty();
        if (maxQty > 0 && newQty > maxQty) newQty = maxQty;
      }
      if (user?.id) {
        if (userexistingarticle) {
          await axios.put(
            `${import.meta.env.VITE_TESTING_API}/cart/${userexistingarticle.cart_id}`,
            { quantity: newQty }
          );
          dispatch(addTocart({
            ...userexistingarticle,
            quantity: newQty
          }));
        } else {
          const response = await axios.post(
            `${import.meta.env.VITE_TESTING_API}/cart?ecom_type=${import.meta.env.VITE_ECOM_TYPE}`,
            { ...props, article_id: props.id, quantity: newQty, user_id: user.id, b_usr_article_variant_combination_id: props?.article_variant_combination?.id }
          );
          dispatch(addTocart({ ...response.data.data, article_variant_combination: props.article_variant_combination }));
        }
        toast.success(addToCartSuccessMessage, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        });
        setaddtocartPopupOpen(false);
        } else {
        // Guest user: allow adding to local redux cart without requiring login
        if (userexistingarticle) {
          // update quantity for existing local cart item
          dispatch(addTocart({
            ...userexistingarticle,
            quantity: newQty,
          }));
          toast.success(addToCartSuccessMessage, {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          });
          
        } else {
          console.log("22222222222222222222222222222222222222222");
          // add new local cart item
          const localId = `local-${Date.now()}`;

          // Helper to normalize incoming cart_items_variants which may be an object keyed by variant ids
          const normalizeCartItemsVariants = (input, cartId) => {
            if (!input) return [];
            // If already an array, try to keep it
            if (Array.isArray(input)) return input;
            // input is object like { "22": { id:68,... }, "23": { id:72,... } }
            const out = [];
            Object.keys(input).forEach((variantKey, index) => {
              const v = input[variantKey];
              // For compatibility, compute a synthetic id for the mapping entry
              const syntheticId = Math.floor(Date.now() / 1000) + index;
              out.push({
                id: syntheticId,
                cart_id: cartId,
                article_variant_id: Number(v.b_usr_article_variant_id || variantKey),
                variant_item_id: Number(v.id || v.b_usr_article_variant_item_id || v.b_usr_article_variant_item_id),
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
                articlevariant: {
                  id: Number(v.b_usr_article_variant_id || variantKey),
                  b_usr_article_id: props.id,
                  nom: v.nom || (v.value ? 'Variant' : ''),
                  is_mandatory: !!v.is_mandatory,
                },
                variantitem: {
                  id: Number(v.id || v.b_usr_article_variant_item_id || v.b_usr_article_variant_item_id),
                  b_usr_article_variant_id: Number(v.b_usr_article_variant_id || variantKey),
                  value: v.value || '',
                  image: v.image || '',
                  quantity: v.quantity || 0,
                  squ: v.squ || '0',
                  price: v.price || '0',
                }
              });
            });
            return out;
          };

          const normalizedVariants = normalizeCartItemsVariants(data?.cart_items_variants, localId);

          const localPayload = {
            _id: props.id ?? localId,
            id: localId,
            title: props.designation,
            author: props.dc_auteur,
            image: props.articleimage?.[0]?.link ? props.articleimage?.[0].link : bookPlaceHolder,
            price: props.prixpublic,
            _qte_a_terme_calcule: props._qte_a_terme_calcule,
            discount: props.discount,
            quantity: newQty,
            description: props.descriptif,
            weight: props._poids_net,
            cart_id: localId,
            price_ttc: props._prix_public_ttc,
            article_stock: props.article_stock,
            cart_items_variants: normalizedVariants,
            localcart_items_variants: data?.cart_items_variants,
            article_variant_combination: props.article_variant_combination,
            child_articles: props.child_articles || []
          };
          console.log(localPayload);
          
          dispatch(addTocart(localPayload));
          // Show confirmation for guest local add
          // setisPopupCartOpen(true);
          setaddedBookCart(props);
          toast.success(addToCartSuccessMessage, {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          });
        }
        setaddtocartPopupOpen(false);
      }
      await fetchfavandcartSettings();
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.error("Failed to add item to cart.", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
    } finally {
      isAddingToCartRef.current = false;
      setIsLoading(false);
    }
  };

  const addToCartWithQtyhandler = async (props) => {
    // console.log(props)
    const maxQuantity = props._qte_a_terme_calcule;
    const item = productData.find(item => item._id === props.id);
    console.log(props);
     if (!item) {
     try {
      setIsLoading(true);
      const response = await axios.post(`${import.meta.env.VITE_TESTING_API}/cart?ecom_type=hanoot`, {
        user_id: user.id,
        article_id: props.id,
        quantity: props.quantity,
        child_articles: props.child_articles || [],
        selectedvariants: Object.values(props.selectedvariants || {}),
        article_variant_combination: props?.article_variant_combination
      });
      dispatch(addTocart({
        _id: props.id,
        title: props.designation,
        author: props.dc_auteur,
        image: props.image,
        price: props.prixpublic,
        _qte_a_terme_calcule: props._qte_a_terme_calcule,
        discount: props.discount,
        quantity: props.quantity,
        description: props.descriptif,
        weight: props._poids_net,
        cart_id: response.data.data.id,
        price_ttc: props._prix_public_ttc,
        article_stock: props.article_stock,
        article_variant_combination: props?.article_variant_combination,
        child_articles: props.child_articles || []
      }));

      // setisPopupCartOpen(true);
      setaddedBookCart(props);
      toast.success(`${language === 'eng' ? "Item is added to Cart" : "L'article est ajouté au panier"}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.error(`${language === 'eng' ? "Failed to add item to cart." : "Échec de l'ajout d'un article au panier."}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      // console.log(error)
    } finally{
      setIsLoading(false);
    };
     } else {
      const newQuantity = Number(item.quantity * 1) + Number(props.quantity * 1);
      const newQuantityMax = Number(maxQuantity) - Number(item.quantity * 1);
      // console.log("item.quantity", item.quantity)
      // console.log("props.quantity", props.quantity)
      // console.log("newQuantity", newQuantity)
      setIsLoading(true);
      if (Number(newQuantity) > Number(maxQuantity)) {
        
        axios.put(`${import.meta.env.VITE_TESTING_API}/cart/${item.cart_id}`, {
          quantity: Number(maxQuantity).toFixed(0),
          })
          .then((response) => {
              // console.log("PUT request successful:", response.data);
              dispatch(addTocart({
                  _id: props.id,
                  quantity: Number(newQuantityMax).toFixed(0),
                }))
                // setisPopupCartOpen(true);
                setaddedBookCart(props);
                setIsLoading(false);
                toast.success(`${language === 'eng' ? "Item is added to Cart" : "L'article est ajouté au panier"}`, {
                  position: "top-right",
                  autoClose: 1500,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: 0,
                  theme: "colored",
                });
          })
          .catch((error) => {
              // console.error("Error in PUT request:", error);
              setIsLoading(false);
              toast.error(`${language === 'eng' ? "Failed to add item to cart." : "Échec de l'ajout d'un article au panier."}`, {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0,
                theme: "colored",
              });
          });
      } else {
        
        axios.put(`${import.meta.env.VITE_TESTING_API}/cart/${item.cart_id}`, {
          quantity: newQuantity,
          })
          .then((response) => {
              // console.log("PUT request successful:", response.data);
              dispatch(addTocart({
                  _id: props.id,
                  quantity: props.quantity,
                }))
                // setisPopupCartOpen(true);
                setaddedBookCart(props);
                setIsLoading(false);
                toast.success(`${language === 'eng' ? "Item is added to Cart" : "L'article est ajouté au panier"}`, {
                  position: "top-right",
                  autoClose: 1500,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: 0,
                  theme: "colored",
                });
          })
          .catch((error) => {
              // console.error("Error in PUT request:", error);
              setIsLoading(false);
              toast.error(`${language === 'eng' ? "Failed to add item to cart." : "Échec de l'ajout d'un article au panier."}`, {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0,
                theme: "colored",
              });
          });
      }
      
    }
  }

  const deleteFromcarthandler = async (props) => {
    const variantId = props?.article_variant_combination?.id;
    const productId = props?._id;
    let item;
    if (variantId) {
      item = productData.find((item) => variantId === item.article_variant_combination?.id && productId === item._id);
    } else {
      item = productData.find((item) => item._id === productId);
    }

    if (!item && productId) {
      item = productData.find((cartItem) => cartItem?._id === productId);
    }

    if (!item) {
      return;
    }

    // Guest users should always delete locally
    if (!user?.id) {
      dispatch(deleteItem(item));
      toast.success(
        language === "eng" ? "Product is removed." : "Le produit est supprimé.",
        {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        }
      );
      return;
    }

    // Otherwise perform the server delete (existing behavior)
    axios
      .delete(`${import.meta.env.VITE_TESTING_API}/cart/${item.cart_id}`)
      .then(() => {
        dispatch(deleteItem(item));
        toast.success(
          language === "eng" ? "Product is removed." : "Le produit est supprimé.",
          {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          }
        );
      })
      .catch((error) => {
        toast.error(
          language === "eng"
            ? "Failed to add item to cart."
            : "Échec de l'ajout de l'article au panier.",
          {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          }
        );
      });
  };

  const fetchArticles = async () => {
    try {
      const url = `${import.meta.env.VITE_TESTING_API}/articles`;
      
      const selectedarticleFamilleId = (articleFamilleId !== 'null' && articleFamilleId !== null)
      ? `&articlefamille_id=${articleFamilleId}`
      : "";
      const finalUrl = `${url}?${selectedarticleFamilleId}&ecom_type=hanoot&selected_date=any&page=1`;

      // Fetch articles using the finalized URL
      const response = await axios.get(finalUrl);
      
      setArticles(response.data.data);
    } catch (error) {
      // console.error('Error fetching articles:', error);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await axios.get(`${import.meta.env.VITE_TESTING_API}/countries?ecom_type=hanoot`);
      setCountries(response.data);
    } catch (error) {
      // console.error('Error fetching countries:', error);
    }
  };

  // const fetchArticles = async () => {
  //   try {
  //     let allArticles = [];
  //     let currentPage = 1;
  //     let totalPages = 10;
  
  //     // Fetch each page until there are no more pages
  //     while (currentPage <= totalPages) {
  //       const response = await axios.get(`${import.meta.env.VITE_TESTING_API}/articles?page=${currentPage}`);
  //       const { data, meta } = response.data;
  
  //       // Update total pages if available
  //       if (meta && meta.pagination && meta.pagination.total_pages) {
  //         totalPages = meta.pagination.total_pages;
  //       }
  
  //       // Add articles from current page to the allArticles array
  //       allArticles = [...allArticles, ...data];
  
  //       // Update the state with the current data
  //       setArticles(allArticles);
  //       console.log(articles)
  
  //       // Move to the next page
  //       currentPage++;
  //     }
  //   } catch (error) {
  //     console.error('Error fetching articles:', error);
  //     toast.error('Failed to fetch articles.');
  //   }
  // };
  
  

  
  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${import.meta.env.VITE_TESTING_API}/categories?ecom_type=hanoot`);
      const sorteddata = [...response.data].sort((a, b) =>
        a._nom.localeCompare(b._nom)
      );
      setCategories(sorteddata);
    } catch (error) {
      // console.error('Error fetching categories:', error);
    }
  };

  
    const fetchCollabTypes = async () => {
      try {
        const response = await axios.get(`${import.meta.env.VITE_TESTING_API}/collaborators/types?ecom_type=hanoot`);
        setCollaboratorsTypes(response.data);
      } catch (error) {
        // console.error('Error fetching collaborator types:', error);
      }
    };
  
  const fetchCollaborators = async () => {
    try {
      const response = await axios.get(`${import.meta.env.VITE_TESTING_API}/collaborators?ecom_type=hanoot`);
      const sorteddata = [...response.data];
      // .sort((a, b) =>
      //   a._nom.localeCompare(b._nom)
      // )
      setCollaborators(sorteddata);
    } catch (error) {
      // console.error('Error fetching collaborators:', error);
      // toast.error('Failed to fetch categories.');
    }
  };
  const fetchCollections = async () => {
    try {
      const response = await axios.get(`${import.meta.env.VITE_TESTING_API}/collections?ecom_type=hanoot`);
      const sorteddata = [...response.data].sort((a, b) =>
        a.nom.localeCompare(b.nom)
      );
      setCollections(sorteddata);
    } catch (error) {
      // console.error('Error fetching collections:', error);
    }
  };

  const fetchPublishers = async () => {
    try {
      // If a category is selected, include it in the publishers request so we get publishers
      // related to that article famille parent. Otherwise fetch all publishers.
      let url = `${import.meta.env.VITE_TESTING_API}/publishers?ecom_type=hanoot`;
      if (selectedCategoryId !== null && selectedCategoryId !== 'null') {
        url += `&articlefamilleparent_id=${encodeURIComponent(selectedCategoryId)}`;
      }
      const response = await axios.get(url);
      const sorteddata = [...response.data].sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      setPublishers(sorteddata);
    } catch (error) {
      // Handle error silently
    }
  };

  
  const fetchSocieteConfig = async () => {
    try {
      const response = await axios.get(`${import.meta.env.VITE_TESTING_API}/societe-config`);
      setSocieteConfig(response.data);
    } catch (error) {
      // console.error('Error fetching collections:', error);
    }
  };
  

  const fetchCompanySettings = async () => {
    try {
      const response = await axios.get(`${import.meta.env.VITE_TESTING_API}/company-settings?ecom_type=hanoot`);
      setCompanySettings(response.data.data);
      if (response.data.data?.usd_rate) {
        setcurrencyRate(response.data.data?.usd_rate)
      }
      localStorage.setItem('favIcon', response.data.data?.fav_icon)
    } catch (error) {
      // console.error('Error fetching articles:', error);
      // toast.error('Failed to fetch articles.');
    }
  };

  
  const fetchArticleFamilleParents = async () => {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_TESTING_API}/article-famille-parents?ecom_type=hanoot`
      );
      response?.data?.sort((a, b) => a.nom.localeCompare(b.nom));
      setArticleFamilleParents(response.data);
    } catch (error) {
      // console.error('Error fetching articles:', error);
    }
  };

  
  const fetchSubSubCat = async () => {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_TESTING_API}/article-sous-categories?ecom_type=hanoot`
      );
      response?.data?.sort((a, b) => a.nom.localeCompare(b.nom));
      setSubsubCategories(response.data);
    } catch (error) {
      // console.error('Error fetching articles:', error);
    }
  };

  
  const fetchArticleFamille = async () => {
    try {
      
      const selectedarticleFamilleId = (articleFamilleId !== 'null' && articleFamilleId !== null)
      ? `&articlefamilleparent_id=${articleFamilleId}`
      : "";
      const response = await axios.get(
        `${import.meta.env.VITE_TESTING_API}/article-famille?ecom_type=hanoot${selectedarticleFamilleId}`
      );

      response?.data?.sort((a, b) => a.type_nom.localeCompare(b.type_nom));
      setarticleFamille(response.data);
      
    } catch (error) {
      // console.error('lkiuhcgdwieolucgeiuhc', error);
    }
  };
  
  const fetchAllArticleFamille = async () => {
    try {
      
      const response = await axios.get(
        `${import.meta.env.VITE_TESTING_API}/article-famille?ecom_type=hanoot`
      );

      setAllarticleFamille(response.data);
      
    } catch (error) {
      // console.error('lkiuhcgdwieolucgeiuhc', error);
    }
  };

  const fetchfavandcartSettings = async () => {
    if (user) {
  try {
    const cartResponse = await axios.get(`${import.meta.env.VITE_TESTING_API}/users/${user.id}/cart`, {
        headers: {
            Authorization: `Bearer ${token}` // Include token in the headers
        }
    });
    const userCart = cartResponse.data.data; 
    dispatch(resetCart());
    console.log('userCart',userCart);
    userCart.forEach(cartItem => {
            dispatch(addInitialcart({
              cart_id: cartItem.id,
              _id: cartItem.article.id,
              title: cartItem.article.designation,
              author: cartItem.article.dc_auteur,
              image: cartItem.article.articleimage?.[0]?.link ? cartItem.article.articleimage?.[0].link : bookPlaceHolder,
              price: cartItem.article.prixpublic,
              _qte_a_terme_calcule: cartItem.article?._qte_a_terme_calcule,
              discount: cartItem.discount,
              _code_barre: cartItem.article._code_barre,
              quantity: cartItem.quantity < cartItem.article?._qte_a_terme_calcule ? cartItem.quantity : Number(cartItem.article?._qte_a_terme_calcule).toFixed(0),
              description: cartItem.article.descriptif,
              weight: cartItem.article._poids_net,
              price_ttc: cartItem.article._prix_public_ttc,
              removed: cartItem.removed,
              child_articles: cartItem.article.child_articles || [],
              article_stock: cartItem.article.article_stock,
              cart_items_variants: cartItem.cart_items_variants,
              article_variant_combination: cartItem.article_variant_combination,
            }));
    });

    const favoriteResponse = await axios.get(`${import.meta.env.VITE_TESTING_API}/users/${user.id}/favorite`, {
        headers: {
            Authorization: `Bearer ${token}` // Include token in the headers
        }
    });
    const favoriteCart = favoriteResponse.data.data; // Assuming cart data is returned in the response
    dispatch(resetfavorite());
    favoriteCart.forEach(favtItem => {
        const article_id = favtItem.article_id;
            dispatch(addTofavorite({
              id: favtItem.id,
              _favid: favtItem.article.id,
              favtitle: favtItem.article.designation,
              favauthor: favtItem.article.dc_auteur,
              favimage: favtItem.article.articleimage?.[0]?.link ? favtItem.article.articleimage?.[0].link : bookPlaceHolder,
              favprice: favtItem.article.prixpublic,
              _qte_a_terme_calcule: favtItem.article?._qte_a_terme_calcule,
              favdescription: favtItem.article.descriptif,
              _code_barre: favtItem.article._code_barre,
              favquantity: 1,
              discount: favtItem.discount,
              weight: favtItem.article._poids_net,
              price_ttc: favtItem.article._prix_public_ttc,
              removed: favtItem.removed,
              favorite_category_id: favtItem.favorite_category_id,
              article_stock: favtItem.article.article_stock
            }));
    });
} catch (error) {
    // const errormsg = error.response.data.error;
    // console.error('Error in Login:', `${errormsg}`);
}
      
    }
}

const setFavPopupHandler = (favPopup) => {
  setFavPopup(favPopup)
}

  const FetchUserData = async () => {
    await fetchfavandcartSettings();
  }

  const checkUserLoggedIn = async () => {
    // Only check if user exists and has an ID
    const sessionEndedMsg = language === "eng"
      ? "Session ended, please login again."
      : "Session terminée, veuillez vous reconnecter.";

    if (!user?.id) {
      if (token) {
        dispatch(removeUser());
        sessionStorage.removeItem('token');
      }
      return { is_logged_in: false };
    }
    
    
    try {
      const response = await axios.post(`${import.meta.env.VITE_TESTING_API}/is-user-logged-in`, {user_id: user.id});
      
      // If response indicates user is not logged in, remove user from state
      if (!response.data.is_logged_in) {
        dispatch(removeUser());
        sessionStorage.removeItem('token');
      toast.info(sessionEndedMsg, {
        toastId: "session-ended",
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      } else {
        FetchUserData();
      }
      
      return response.data;
    } catch (error) {
      // If request fails (e.g., unauthorized), assume user is not logged in
      dispatch(removeUser());
      sessionStorage.removeItem('token');
      toast.info(sessionEndedMsg, {
        toastId: "session-ended",
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      return { is_logged_in: false };
    }
  };

  useEffect(() => {
    const initializeApp = async () => {
      fetchSocieteConfig();
      await checkUserLoggedIn();
    fetchArticleFamilleParents();
    fetchSubSubCat();
    fetchArticleFamille();
    fetchAllArticleFamille();
    fetchArticles();
    fetchCategories();
    fetchCompanySettings();
    fetchCollabTypes();
    fetchCollaborators();
    fetchCollections();
    fetchCountries();
    fetchPublishers();
    };

    initializeApp();
  }, []);
  
  useEffect(() => {
    fetchPublishers();
  }, [selectedCategoryId]);

  const addToFavoritehandler = async (props) => {
    if (!user?.id) {
      toast.error(`${language === 'eng' ? "Please login to add to Wishlist." : "Veuillez vous connecter pour ajouter à la liste de souhaits."}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
    } else {
    setSelectedProduct(props);
    setFavPopup(true);
  }
  }
  const addToFavoriteWithCatigoryhandler = async (categoryId) => {
    console.log(categoryId);
    setFavPopup(false);
    
    const item = favorites.find(item => item._favid === props.id);
     try {
      const response = await axios.post(`${import.meta.env.VITE_TESTING_API}/favorites`, {
        user_id: user.id,
        article_id: selectedProduct.id,
        favorite_category_id: categoryId,
        ecom_type: 'hanoot'
      });
      dispatch(addTofavorite({
        id: response.data.data.id,
        _favid: selectedProduct.id,
        favtitle: selectedProduct.designation,
        favauthor: selectedProduct.dc_auteur,
        favimage: selectedProduct.articleimage?.[0]?.link ? selectedProduct.articleimage?.[0].link : bookPlaceHolder,
        favprice: selectedProduct.prixpublic,
        _qte_a_terme_calcule: selectedProduct._qte_a_terme_calcule,
        discount: selectedProduct.discount,
        favquantity: 1,
        favdescription: selectedProduct.descriptif,
        weight: selectedProduct._poids_net,
        price_ttc: selectedProduct._prix_public_ttc,
        favrate: selectedProduct.average_rate,
        favorite_category_id: categoryId,
        article_stock: selectedProduct.article_stock
      }));

      // console.log("652314654",{
      //   id: response.data.data.id,
      //   _favid: selectedProduct.id,
      //   favtitle: selectedProduct.designation,
      //   favauthor: selectedProduct.dc_auteur,
      //   favimage: selectedProduct.articleimage?.[0]?.link ? selectedProduct.articleimage?.[0].link : bookPlaceHolder,
      //   favprice: selectedProduct.prixpublic,
      //   _qte_a_terme_calcule: selectedProduct._qte_a_terme_calcule,
      //   discount: selectedProduct.discount,
      //   favquantity: 1,
      //   favdescription: selectedProduct.descriptif,
      //   weight: selectedProduct._poids_net,
      //   price_ttc: selectedProduct._prix_public_ttc,
      //   favrate: selectedProduct.average_rate,
      //   favorite_category_id: categoryId,
      //   article_stock: selectedProduct.article_stock
      // });
      

      toast.success(`${language === 'eng' ? `Product is added to Favorites` : "Le produit est ajouté à la liste de souhaits"}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
    } catch (error) {
      console.error("Error adding to Favorites:", error);
      toast.error(`${language === 'eng' ? "Failed to add item to Wishlist." : "Échec de l'ajout d'un article à la liste de souhaits."}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
    };
  }

  const deleteFavoritehandler = async (props) => {
    const item = favorites.find(item => item._favid === props);
    console.log(item)
     try {
      const response = await axios.delete(`${import.meta.env.VITE_TESTING_API}/favorites/${item.id}`);
      dispatch(deletefavorite(item.id));

      toast.success(`${language === 'eng' ? "Book is removed from wishlist" : "Le article est retiré de la liste de souhaits"}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
    } catch (error) {
      toast.error(`${language === 'eng' ? "Failed to remove book from wishlist." : "Le article n'a pas été supprimé de la liste de souhaits."}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
    };
  }

  const seteditReturnDatahandler = (editreturnData) => {
    seteditReturnData(editreturnData)
  }
  
  const setReturnDatahandler = (returnData) => {
    setReturnData(returnData)
  }

  
  const setArticleshandler = (articles) => {
    setArticles(articles)
  }

  const setCompanySettingshandler = (articles) => {
    setCompanySettings(articles)
  }

  const contextValue = {
    selectedcurrency: selectedcurrency,
    currencyRate: currencyRate,
    isPopupCartOpen: isPopupCartOpen,
    addedBookCart: addedBookCart,
    selectedlanguage: selectedlanguage,
    reviewData: reviewData,
    bookDetails: bookDetails,
    returnData: returnData,
    editreturnData: editreturnData,
    isLoading: isLoading,
    articles: articles,
    categories: categories,
    articleFamille: articleFamille,
    allarticleFamille: allarticleFamille,
    articleFamilleParents: articleFamilleParents,
    subsubCategories: subsubCategories,
    companySettings: companySettings,
    ReturnSelectedPage: ReturnSelectedPage,
    setReturnSelectedPage: setReturnSelectedPage,

    fetchArticles: fetchArticles,
    fetchCompanySettings: fetchCompanySettings,
    fetchCategories: fetchCategories,
    setcurrencyRate: setcurrencyRate,
    setselectedcurrency: setselectedcurrency,
    setselectedlanguage: setselectedlanguage,
    setReviewData: setReviewDatahandler,
    setbookDetails: setBookDetailshandler,
    deleteFromcart: deleteFromcarthandler,
    addToCart: addToCarthandler,
    addToCartWithQty: addToCartWithQtyhandler,
    addToFavorite: addToFavoritehandler,
    addToFavoriteWithCatigory: addToFavoriteWithCatigoryhandler,
    deleteFavorite: deleteFavoritehandler,
    seteditReturnData: seteditReturnDatahandler,
    setReturnData: setReturnDatahandler,
    setArticles: setArticleshandler,
    setCompanySettings: setCompanySettingshandler,
    setisPopupCartOpen: setisPopupCartOpen,
    setaddedBookCart: setaddedBookCart,
    collaborators: collaborators,
    fetchCollaborators: fetchCollaborators,
    collections: collections,
    fetchCollections: fetchCollections,
    fetchfavandcartSettings: fetchfavandcartSettings,
    
    favPopup: favPopup,
    setFavPopup: setFavPopupHandler,
    countries,

    societeConfig,

    publishers,

    
    addtocartPopupOpen,
    setaddtocartPopupOpen,
    addtocartPopupId,
    setaddtocartPopupId,

    collaboratorsTypes
  }

  
  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;


